import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import store from './store'
import directive from './directive' // directive
import Element from 'element-ui'
import VForm from 'vform-builds'  //引入VForm库
import * as echarts from 'echarts'
import axios from 'axios'  //如果需要axios，请引入
import VueClipboard from 'vue-clipboard2'

import './assets/styles/element-variables.scss'
import './assets/iconfont/iconfont.css'
import './assets/fonts/menu-appends/webapp/iconfont.css'
import '@/assets/styles/index.scss'
import 'vform-builds/dist/VFormDesigner.css'  //引入VForm样式
import '@/components/flow/iconfont'
import { getConfigKey } from "@/api/system/config"
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/common"
import { download } from '@/api/request'
import scroll from 'vue-seamless-scroll'
import { validatePassword } from "@/utils/security"
import { ItemStatus } from '@/libs/constants'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

// 注册为 Vue 指令
Vue.directive('perfect-scrollbar', {
  inserted(el, binding) {
    const ps = new PerfectScrollbar(el, binding.value || {})
    el._ps = ps
  },
  componentUpdated(el) {
    el._ps.update()
  },
  unbind(el) {
    el._ps.destroy()
    el._ps = null
  }
})
Vue.use(scroll)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
// 全局方法挂载
Vue.prototype.$pwdValidator = validatePassword
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.GlobalStatus = {
  'ItemStatus': ItemStatus
}
/** 转换部门数据结构 */
Vue.prototype.normalizer = (node) => {
  if (node.children && !node.children.length) {
    delete node.children
  }
  return {
    id: node.deptId,
    label: node.deptName,
    children: node.children
  }
}
/** 转换空间数据结构 */
Vue.prototype.normalizerForArea = (node) => {
  if (node.children && !node.children.length) {
    delete node.children
  }
  return {
    id: node.areaId,
    label: node.areaName,
    children: node.children
  }
}
Vue.use(VueClipboard)
Vue.use(directive)
Vue.use(Element, {
  size: 'medium' // set element-ui default size
})

Vue.use(VForm)  //全局注册VForm(同时注册了v-form-designer和v-form-render组件)
window.axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
